import getOptionsFromPrefix from '../helpers/getOptionsFromPrefix';

require('nestable2');

const defaultNestableOptions = {
  maxDepth: 5,
};

const Sort = {
  /**
   * Create Sort component
   * @param {HTMLElement} node
   * @param {Object} props
   * @return {Void}
   */
  create(node, props) {
    const options = { ...defaultNestableOptions, ...getOptionsFromPrefix(props, 'sort') };

    // Ensure that max depth is an integer
    options.maxDepth = parseInt(options.maxDepth, 10);

    // Save options and element for later usage
    this.node = node;
    this.options = options;

    // Create Nestable
    $(node)
      .nestable(options)
      .on('change', this.onChange.bind(this));

    // If outputting to hidden input, also do it on load
    if (typeof this.options.output !== 'undefined') {
      this.onChange();
    }
  },

  /**
   * Listen to changes on the Nestable
   * @return {Void}
   */
  onChange() {
    const data = $(this.node).nestable('serialize');

    if (typeof this.options.webhook !== 'undefined') {
      this.postToWebhook(data, this.options.webhook);
    }

    if (typeof this.options.output !== 'undefined') {
      this.saveToInput(data, this.options.output);
    }
  },

  /**
   * Save data to hidden input field
   * @param {Array} data Array with objects representing the nestable items
   * @param {String} id ID of the hidden input field
   * @return {Void}
   */
  saveToInput(data, id) {
    const node = document.getElementById(id);
    node.value = JSON.stringify(data);
  },

  /**
   * Post data to API
   * @param {Array} data Array with objects representing the nestable items
   * @param {String} url URL to POST the data to
   * @return {Void}
   */
  postToWebhook(data, url) {
    window.axios.post(url, data)
      .then((/* res */) => {
        // console.log(res);
      })
      .catch((err) => {
        console.error(err); // eslint-disable-line
      });
  },
};

export default Sort;
